import { render, staticRenderFns } from "./ModalNewExercise.vue?vue&type=template&id=60093d98&scoped=true&"
import script from "./ModalNewExercise.vue?vue&type=script&lang=js&"
export * from "./ModalNewExercise.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewExercise.vue?vue&type=style&index=0&id=60093d98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60093d98",
  null
  
)

export default component.exports